import React from 'react';

import PillComponent from '../../../../pillComponent/pillComponent';
import QuestionWithTooltipComponent from '../../../questionWithTooltipComponent/questionWithTooltipComponent';
import TitleComponentV2 from '../../../titleComponentV2/titleComponentV2';
import UpgradeComponent from '../../../upgradeComponent/upgradeComponent';

import './inputTitleComponent.css';

const InputTitleComponent = ({
  billingPlanFeature,
  linkTxt = 'Read more.',
  linkUrl = '',
  pillType = null,
  titleTxt = '',
  toolTipPosition = 'right',
  toolTipTxt = '',
}) => {
  return (
    <div className="et-v2-input-title-component-container">
      {titleTxt && (
        <TitleComponentV2
          linkTxt={linkTxt}
          linkUrl={linkUrl}
          titleTxt={titleTxt}
        />
      )}
      {toolTipTxt && (
        <>
          <div className="et-n-input-title-tooltip-upgrade-btn-separator" />
          <QuestionWithTooltipComponent
            toolTipPosition={toolTipPosition}
            toolTipTxt={toolTipTxt}
          />
        </>
      )}
      <UpgradeComponent
        billingPlanFeature={billingPlanFeature}
        isCrown={true}
      />
      {pillType && <PillComponent pillType={pillType} />}
    </div>
  );
};

export default InputTitleComponent;
